import _styled from "@emotion/styled-base";
import React from 'react';
import PropTypes from 'prop-types';
// Emotion

import { Transition } from 'react-spring/renderprops';
import { jsx as ___EmotionJSX } from "@emotion/core";
const StdError = /*#__PURE__*/_styled('span', {
  target: "eay7oyo0"
})("color:", _ref => {
  let {
    theme
  } = _ref;
  return theme.error.base;
}, ";display:block;font-size:0.875rem;position:absolute;text-align:left;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdGFuZGFyZC1maWVsZHMvYXRvbXMvRXJyb3IuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU0rQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3RhbmRhcmQtZmllbGRzL2F0b21zL0Vycm9yLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuLy8gRW1vdGlvblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgVHJhbnNpdGlvbiB9IGZyb20gJ3JlYWN0LXNwcmluZy9yZW5kZXJwcm9wcyc7XG5cbmNvbnN0IFN0ZEVycm9yID0gc3R5bGVkKCdzcGFuJylgXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmVycm9yLmJhc2V9O1xuICBkaXNwbGF5OiBibG9jaztcbiAgZm9udC1zaXplOiAwLjg3NXJlbTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuYDtcblxuY29uc3QgRXJyb3IgPSAoeyBzaG93LCBlcnJvciB9KSA9PiAoXG4gIDxUcmFuc2l0aW9uXG4gICAgaXRlbXM9e3Nob3d9XG4gICAgZnJvbT17eyBvcGFjaXR5OiAwLCBib3R0b206ICctMTJweCcgfX1cbiAgICBlbnRlcj17eyBvcGFjaXR5OiAxLCBib3R0b206ICctMjBweCcgfX1cbiAgICBsZWF2ZT17eyBvcGFjaXR5OiAwIH19XG4gICAgY29uZmlnPXt7IGR1cmF0aW9uOiAxNTAgfX1cbiAgPlxuICAgIHsvKiBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbm8tc2hhZG93ICovfVxuICAgIHtzaG93ID0+IHNob3cgJiYgKHN0eWxlID0+IDxTdGRFcnJvciBzdHlsZT17c3R5bGV9PntlcnJvcn08L1N0ZEVycm9yPil9XG4gIDwvVHJhbnNpdGlvbj5cbik7XG5cbkVycm9yLnByb3BUeXBlcyA9IHtcbiAgZXJyb3I6IFByb3BUeXBlcy5vbmVPZlR5cGUoW1Byb3BUeXBlcy5zdHJpbmcsIFByb3BUeXBlcy5ib29sXSksXG4gIHNob3c6IFByb3BUeXBlcy5ib29sLFxufTtcblxuZXhwb3J0IHsgRXJyb3IgfTtcbiJdfQ== */"));
const Error = _ref2 => {
  let {
    show,
    error
  } = _ref2;
  return ___EmotionJSX(Transition, {
    items: show,
    from: {
      opacity: 0,
      bottom: '-12px'
    },
    enter: {
      opacity: 1,
      bottom: '-20px'
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: 150
    }
  }, show => show && (style => ___EmotionJSX(StdError, {
    style: style
  }, error)));
};
Error.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  show: PropTypes.bool
};
export { Error };